import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';

import OSCaseReport from './OSCaseReport.js';

const styles = {
	appBar: {
		position: 'relative',
	},
	flex: {
		flex: 1,
	},
};

function Transition(props) {
	return <Slide direction="up" {...props} />;
}

class OSCaseReportDialog extends React.Component {
	state = {
		open: false,
	};

	handleClickOpen = () => {
		this.setState({ open: true });
	};

	handleClose = () => {
		this.setState({ open: false });
	};

	render() {
		const { classes } = this.props;
		return (
			<div>
			  <Button onClick={this.handleClickOpen}>Case Summary</Button>
			  <Dialog
				fullScreen
				open={this.state.open}
				onClose={this.handleClose}
				TransitionComponent={Transition}
				>
				<Toolbar>
				  <IconButton color="inherit" onClick={this.handleClose} aria-label="Close">
					<CloseIcon />
				  </IconButton>
				  <Typography variant="h6" color="inherit" className={classes.flex}>
					Sound
				  </Typography>
				  <Button color="inherit" onClick={this.handleClose}>
					save
				  </Button>
				</Toolbar>						
				<OSCaseReport arrIndex={this.props.arrIndex} />		  
			  </Dialog>
			</div>
		);
	}
}

OSCaseReportDialog.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(OSCaseReportDialog);
